import { useEffect } from "react";

const Scroll = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scrollup = document.querySelector(".scrollup");
      if (!scrollup) return;
      if (window.scrollY >= 560) {
        scrollup.classList.add("show-scrollup");
      } else {
        scrollup.classList.remove("show-scrollup");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <a href="#top" className="scrollup">
      <i className="uil uil-arrow-up scrollup__icon" />
    </a>
  );
};

export default Scroll;
